export default __webpack_public_path__ + "static/media/twitterX.3d19403e.svg";